import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyAuditOverview = lazyWithRetry(() => import("./AuditOverview"));

const AuditOverview = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAuditOverview {...props} />;

export default AuditOverview;
